import React, { useEffect, useState } from 'react';
import Slider from '@mui/material/Slider';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import MusicOffIcon from '@mui/icons-material/MusicOff';

import styles from './VolumeAdjuster.module.scss';

import {
  pauseMusicLoop,
  playSound,
  setVolume,
  startMusicLoop,
} from 'src/modules/soundHandler';

interface VolumeAdjusterPropsInterface {
  soundType: 'effect' | 'music';
}
const VolumeAdjuster = ({ soundType }: VolumeAdjusterPropsInterface) => {
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [soundVolume, setSoundVolume] = useState(30);
  // TODO: Save volume in local storage.

  const toggleVolume = () => {
    setSoundEnabled((prevState) => {
      setVolume(soundType, prevState ? 0 : soundVolume / 100);
      playSound('tilesSubmitted');

      if (prevState) {
        localStorage.setItem(`${soundType}-volume`, '0');
      } else {
        localStorage.setItem(`${soundType}-volume`, `${soundVolume / 100}`);
      }

      return !prevState;
    });
  };

  const submitChangeVolume = (newValue: number) => {
    setVolume(soundType, newValue / 100);
    playSound('tilesSubmitted');

    localStorage.setItem(`${soundType}-volume`, `${newValue / 100}`);
  };

  useEffect(() => {
    const volumeString = localStorage.getItem(`${soundType}-volume`);
    const volume = volumeString !== null ? Number(volumeString) : soundVolume;

    if (soundType === 'music') {
      startMusicLoop(volume !== 0);
    }

    if (volumeString !== null) {
      if (volume === 0) {
        setSoundEnabled(false);
      } else {
        setSoundVolume(volume * 100);
      }
      setVolume(soundType, volume, false);
    }

    if (soundType === 'music') {
      return () => {
        pauseMusicLoop();
      };
    }
  }, []);

  return (
    <div className={styles.VolumeAdjuster}>
      <div className={styles['sound-icon']} onClick={toggleVolume}>
        {soundType === 'effect' &&
          (soundEnabled ? (
            <VolumeUpIcon color="primary" fontSize="small" />
          ) : (
            <VolumeOffIcon fontSize="small" />
          ))}
        {soundType === 'music' &&
          (soundEnabled ? (
            <MusicNoteIcon color="primary" fontSize="small" />
          ) : (
            <MusicOffIcon fontSize="small" />
          ))}
      </div>
      <Slider
        size="small"
        min={0}
        max={100}
        className={styles.slider}
        value={soundVolume}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onChange={(_event, newValue) => setSoundVolume(newValue)}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onChangeCommitted={(_event, newValue) => submitChangeVolume(newValue)}
        disabled={!soundEnabled}
      />
    </div>
  );
};

export default VolumeAdjuster;
